import React, { useEffect, useState } from 'react';
import { LeftCircleOutlined } from '@ant-design/icons'
import { FetchVariable } from '../../Components/FetchVariable/FetchVariable';
import { Button } from 'antd'
import {useLocation} from "react-router-dom";
import { Figure, Container, Row, Col } from 'react-bootstrap'
import  ContactUs  from "../ContactUs/ContactUs"
import './SingleVehicle.scss'

function SingleVehicle() {

    let data = useLocation()
    let splitData = data.pathname.split('/')

    const [singleVehicleInfo, setSingleVehicle] = useState([]);

    useEffect(() => {
        fetch([`${FetchVariable.Heroku}/vehicle/single-vehicle/${splitData[2]}`])
          .then(response => response.json())
          .then(singleVehicle => {
            setSingleVehicle(singleVehicle);
            console.log(singleVehicle)
          })
          .catch(err => console.log(err));
      }, []); // eslint-disable-line

    if(!singleVehicleInfo){
        return(
            <p>Loading data...</p>
        )
    }
    else{

    return (
        <div className="singleVehicle">
          <Container >
          <Row>
            <Col sm={4}>
          <Figure className="vehicle__img">
            <Figure.Image
              width={680}
              height={480}
              alt="171x180"
              src={singleVehicleInfo.ImageURL}
              />
            <Figure.Caption className="vehicle__text">
              Our Price: ${singleVehicleInfo.SalesPrice}
            </Figure.Caption>
          </Figure>
          </Col>
          </Row>
          </Container>
        <section className="singleVehicleShow">
        <div className="overlaySingle"></div>
        <div className="singleVehicleText">
          <Button type="text" href="/vehicle-catalog" style={{color: "red", marginTop: "-125px" , position: "absolute"}} icon={<LeftCircleOutlined  style={{fontSize: '50px'}}/>}></Button>
          <h2 className="singleVehicleMake">{singleVehicleInfo.Make}</h2>
          <h3>{singleVehicleInfo.Model}</h3>
          <p>{singleVehicleInfo.VehicleYear}</p>
          <p>VIN: {singleVehicleInfo.VehicleVIN}</p>
          <ContactUs vehicleName={singleVehicleInfo.Model} vehicleYear={singleVehicleInfo.VehicleYear} vehicleVIN={singleVehicleInfo.VehicleVIN}/>
        </div>
        <ul className="vehicle__list">
        <h2 className="vehicle__list__header">Car Details</h2>
          <li className="vehicle__list__link2">{singleVehicleInfo.VehicleMiles} Miles </li>
          <li className="vehicle__list__break">||</li>
          <li className="vehicle__list__link3">{singleVehicleInfo.VehicleMPG} MPG</li>
          <li className="vehicle__list__break">||</li>
          <li className="vehicle__list__link4">{singleVehicleInfo.VehicleCondition} Condition</li>
          <li className="vehicle__list__break">||</li>
          <li className="vehicle__list__link4">Color {singleVehicleInfo.VehicleColor}</li>
        </ul>
      </section>
      <section>
      </section>
      </div>
    )
}

}
export default SingleVehicle;
